module.exports = __webpack_public_path__ + "img/authority.a2e1e60b.png";